'use client';

import Image from 'next/image';
import Link from 'next/link';

const LogoLink = ({ href, src, alt }: LogoLinkProps) => {
  return (
    <Link
      href={href}
      scroll
      className="flex h-16 items-center"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <Image
        src={src}
        alt={alt}
        width={56}
        height={56}
        className="h-12 desktop:h-16 w-auto"
        priority
      />
    </Link>
  );
};

export default LogoLink;

type LogoLinkProps = {
  href: string;
  src: string;
  alt: string;
};
